import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioButtonComponent } from './radiobutton.component';
/**
 * NgModule definition for the RadioButton component.
 */
export class RadioButtonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        RadioButtonComponent
    ],
    exports: [
        RadioButtonComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RadioButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
RadioButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RadioButtonModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
